export const K8_SCHOOL_SUMMARY_GRADES = [
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
]

export const K12_SCHOOL_SUMMARY_GRADES = [
  ...K8_SCHOOL_SUMMARY_GRADES,
  'Grade 9',
  'Grade 10',
  'Grade 11',
  'Grade 12',
]

/** Empty set = show all grades; checked boxes narrow the list. */
export const createDefaultGradeSelection = () => new Set()
